import { render, staticRenderFns } from "./RoleGroup.vue?vue&type=template&id=78ad3bf6&"
import script from "./RoleGroup.vue?vue&type=script&lang=js&"
export * from "./RoleGroup.vue?vue&type=script&lang=js&"
import style0 from "./RoleGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\001.src\\003.aikl_wrokspace\\aikl_v2_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78ad3bf6')) {
      api.createRecord('78ad3bf6', component.options)
    } else {
      api.reload('78ad3bf6', component.options)
    }
    module.hot.accept("./RoleGroup.vue?vue&type=template&id=78ad3bf6&", function () {
      api.rerender('78ad3bf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/RoleGroup.vue"
export default component.exports